import API from "../api";

export const getProduk = () => API.get("/produk");
export const addProduk = (data) => API.post("/produk", data);
export const updateProduk = (id, data) => API.put(`/produk/${id}`, data);
export const deleteProduk = (id) => API.delete(`/produk/${id}`);
